import imagesLoaded from 'imagesloaded';
import 'remodal'
import { CookieConsent } from 'cookieconsent';

require('waypoints/lib/noframework.waypoints.js');

/*
    Add class to body once all images are loaded
*/
imagesLoaded( document.querySelector('#main'), function( instance ) {
    $('body').addClass('page-loaded')
});
